<template>
  <li class="nav-item">
    <a class="nav-link theme-toggle-btn" href="#" @click.prevent="toggleTheme" :title="Obscuro ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'">
      <i :class="Obscuro ? 'fas fa-moon' : 'fas fa-sun'" class="theme-toggle-icon"></i>
      <p class="d-lg-none">{{ Obscuro ? 'Tema Claro' : 'Tema Oscuro' }}</p>
    </a>
  </li>
</template>

  <script>
    import BaseService from '@/api-services/base.service'
    export default {
      name: 'Main-Tema',
      data() {
        return {
          Obscuro: true,
        }
      },
      mounted() {
        if (localStorage.Obscuro != null) {
          this.Obscuro = localStorage.Obscuro == "true";
        }
      },
      watch: {
        Obscuro(nuevoValor) {
          if (localStorage.Obscuro != nuevoValor) {
            localStorage.Obscuro = nuevoValor;
            this.$appInsights.trackEvent({ name: this.$options.name }, { Obscuro: nuevoValor });
          }
          BaseService.CabiarTema(nuevoValor);
        },
      },
      methods: {
        toggleTheme() {
          this.Obscuro = !this.Obscuro;
        },
      }
    };</script>
  <style lang="scss" scoped>
    .theme-toggle-btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0.5rem 0.75rem;
    }
    .theme-toggle-icon {
      font-size: 1.15rem;
      transition: transform 0.3s ease, color 0.3s ease;
    }
    .theme-toggle-btn:hover .theme-toggle-icon {
      transform: rotate(30deg);
    }
    .fa-sun {
      color: #f5a623;
    }
    .fa-moon {
      color: #adb5bd;
    }
  </style>
